import '../scss/main.scss';
import './functions.js'

if (process.env.NODE_ENV !== 'production') {
    import("./dev").then((_module) => {
        
    })
}


register_form(document);
function register_form($root = document) {
    const $form = $root.querySelector('#contact');
    if (!$form) {
        return;
    }
    $form.addEventListener('submit', event => {
        event.preventDefault();
        const err = check($form.parentNode);
        console.log({err});
        if (err) {
            return;
        }
        const config = JSON.parse($form.dataset.config);
        const form_data = new FormData(event.target);
        console.log({ config });
        const clean_data = [];
        for (const [name, value] of form_data.entries()) {
            if (value === '') {
                continue;
            }
            const $el = $form.elements[name];
            let clean_value;
            switch ($el.type) {
                case "checkbox":
                    clean_value = value === "on";
                    break
                case "number":
                    clean_value = parseFloat(value);
                    break
                default:
                    clean_value = value;
                    break
            }
            clean_data.push([name, clean_value]);
        }
        const request_body = Object.fromEntries(clean_data);
        request_body.meta = config.meta;
        fetch(config.form.action, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request_body)
        })
            .then(result => result.json())
            .then(data => {
                console.log(data);

                if (!data.message) {
                    //@todo
                    return;
                }

                const $parent = $form.parentNode;
                $parent.innerHTML = "";
                const $message = document.createElement('p');
                $message.innerHTML = data.message;
                $parent.appendChild($message);
            })
            .catch(console.warn);
    });
}

function check($fieldset) {
    const $inputs = $fieldset.querySelectorAll('input, select, textarea');
    let err = false;
    let $input_first = null;
    $inputs.forEach($input => {
        if ($input.required && $input.value === '' || !$input.validity.valid) {
            if (!$input_first) {
                $input_first = $input;
            }
            $input.classList.add('error');
            err = true;
        } else {
            $input.classList.remove('error');
        }
    });
    if (err) {
        $input_first.scrollIntoView({ behavior: 'smooth', block: 'start' });
        $input_first.focus({ preventScroll: true });
    }
    return err;
}

register_team(document);
function register_team($root = document) {
    const $team_modules = $root.querySelectorAll('.name--team');
    $team_modules.forEach($module => {
        const $els = $module.querySelectorAll('.team-list li');
        $els.forEach($el => {
            $el.addEventListener('click', _event => {
                $module.classList.add('opened');
                $el.classList.add('opened');
            });
            const $close = $el.querySelector('.close');
            $close.addEventListener('click', event => {
                event.stopPropagation();
                $module.classList.remove('opened');
                $el.classList.remove('opened');
            });
        });
    });
}